import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Alert, FormGroup, Button } from 'reactstrap';
import { Link } from 'react-router-dom';

import * as gatewayActions from '../../actions/gatewayActions';
import { ColLeft, ColRight, RenderSettings } from './utils';

// Migrated from redux-form to react-hook-form. The `settings` FieldArray is now the
// RenderSettings component (useFieldArray); the `enabled` checkbox uses register on a
// native input (reactstrap Input wants innerRef, and the Controller adapter mis-reads
// a checkbox event). Cancel resets the form to initialValues (redux-form reset()).
function SettingsForm({ currentGatewayStore, currentStore, initialValues }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);

  const buildDefaults = () => ({ enabled: false, settings: [], ...initialValues });
  const { control, register, handleSubmit, reset } = useForm({ defaultValues: buildDefaults() });

  const initKey = JSON.stringify(initialValues);
  useEffect(() => {
    reset(buildDefaults());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initKey]);

  const submit = async (store) => {
    try {
      const settings = {};
      if (store.settings) {
        store.settings.forEach((item) => {
          settings[item.name] = item.value;
        });
      }
      const data = {
        storeId: currentGatewayStore.storeId,
        settings,
        enabled: store.enabled,
      };

      const storeId = data.storeId;
      await dispatch(gatewayActions.saveStore(storeId, data));
      await dispatch(gatewayActions.getStore(storeId));
      setMessage('Saved successfully');
      setError(false);
    } catch (err) {
      setMessage('Failed to save, reason: ' + err.message);
      setError(true);
    }

    return false;
  };

  const onCancel = () => {
    reset(buildDefaults());
  };

  const { integrations = [] } = currentGatewayStore;

  return (
    <>
      <h5>Gateway Settings</h5>
      <hr className="separator" />
      <form onSubmit={handleSubmit(submit)} className="form-horizontal">
        {message && <Alert color={error ? 'danger' : 'success'}>{message}</Alert>}
        <FormGroup row>
          <ColLeft>Enabled</ColLeft>
          <ColRight>
            <input type="checkbox" id="enabled" className="form-check-input" {...register('enabled')} />
          </ColRight>
        </FormGroup>
        <FormGroup row style={{ marginBottom1: 0 }}>
          <ColLeft>Settings</ColLeft>
          <ColRight>
            <RenderSettings control={control} register={register} name="settings" />
          </ColRight>
        </FormGroup>
        <div className="float-end">
          <Button type="button" color="secondary" className="me-2" onClick={() => onCancel()}>
            Cancel
          </Button>
          <Button type="submit" color="primary">
            Save
          </Button>
        </div>
        <div style={{ clear: 'both' }}></div>
        <div className="mt-3">
          <hr className="separator" />
        </div>

        <FormGroup row>
          <ColLeft>Integrations</ColLeft>
          <ColRight>
            <ul className="list-unstyled" style={{ marginBottom: 2 }}>
              {integrations.map((integration, i) => (
                <li key={i}>
                  <Link to={`/stores/${currentStore.id}/gateway/integrations/${integration}`}>{integration}</Link>
                </li>
              ))}
            </ul>
            <div className="float-end">
              <Button
                type="button"
                color="primary"
                onClick={() => {
                  navigate(`/stores/${currentStore.id}/gateway/integrations-add`);
                }}
              >
                Add Integration
              </Button>
            </div>
          </ColRight>
        </FormGroup>
      </form>
    </>
  );
}

export default SettingsForm;
